export const container = "flex fixed inset-0 z-50 bg-black bg-opacity-50";
export const main = "min-h-screen h-screen md:h-full bg-white transition-transform duration-300 w-3/5 md:w-60 border-r overflow-y-auto hide-scrollbar";
export const userInfo = "px-2 py-4 flex items-center border-b border-gray-200";
export const businessLogo = "bg-black text-white flex justify-center items-center h-10 w-12 rounded-full";
export const businessName = "text-md font-bold";
export const businessDetails = "flex items-center text-xs gap-2";
export const closeIcon = "text-lg cursor-pointer md:hidden";
export const getStartedSection = "flex flex-col gap-3 border-b border-gray-200 py-4 px-2 text-sm font-thin";
export const getStartedContainer = "flex items-center justify-center gap-2 rounded-lg";
export const currencyButton = "flex items-center justify-center bg-transparent border border-gray-300 rounded-full py-4 text-sm";
export const generalContainer = "border-b border-gray-200 py-4 px-2";
export const categoryHeader = "text-sm font-thin text-left mb-2";
export const dashboardItemContainer = "flex flex-col items-center text-sm my-6";
export const linkItemContainer = "flex items-center justify-between cursor-pointer my-2";
export const supportContainer = 'py-4 px-2';
export const linkItem = "flex items-center gap-2";
export const linkIcon = "w-5 h-5";
export const hrStyles = "border-0 h-0.5 bg-black";
export const subItemContainer = "ml-6 mt-2 space-y-1";
export const subItem = "text-sm py-2 pl-4 rounded-lg hover:cursor-pointer";
export const getSidebarItemClass = (activeItem: string | null, currentItem: string) => {
  return `flex gap-2 text-sm p-2 rounded-lg ${activeItem === currentItem ? 'bg-gray-200 border-l-4 font-semibold border-gray-500' : 'font-thin'}`;
};
